import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from 'infrastructure/common/model/api.query';
import { userNotes } from 'user/model/iam-user-note.fragments';
import { UserMoodOutput } from 'user/model/user-mood.output';
import { UserNoteOutput } from 'user/model/user-note.output';

@Injectable({ providedIn: 'root' })
export class OwnedUserMoodsApiQuery extends ApiQuery<UserMoodOutput[], void> {
	client = 'iam';
	document = gql`
		query ownedUserMoods {
			ownedUserMoods {
				id
				mood
				feelings
				creationTimestamp
			}
		}
	`;
	method = 'ownedUserMoods';
}
